<template>
<div v-if="actividadesNivel">
  <h3>Horario extraescolares</h3>

  <div class="row pt-2 pb-3">
    <div class="col-md-6">
      Curso:
      <b-dropdown id="dropdown-nivel" :text="nivelSeleccionado.nombre">
        <b-dropdown-item @click="seleccionarNivel(0)">Todos</b-dropdown-item>
        <b-dropdown-item v-for="nivel in niveles" :key="nivel.id_nivel" @click="seleccionarNivel(nivel.id_nivel)">{{ nivel.nombre }}</b-dropdown-item>
      </b-dropdown>
    </div>

    <div class="col-md-6 text-right">
      <b-form-group>
        <b-form-radio-group
          id="listado-horario"
          name="listado-horario"
          v-model="formatoCuadro"
          :options="['Listado', 'Horario']"
          buttons
          button-variant="outline-secondary"
        ></b-form-radio-group>
      </b-form-group>
    </div>

  </div>

  <table v-if="formatoCuadro == 'Listado'" class="table">
    <thead>
      <tr class="table-success">
      <th class="px-1 py-2 p-md-2" style="width:40%">Grupo</th>
      <th class="px-1 py-2 p-md-2 text-center" style="width:32%">Cursos</th>
      <th class="px-1 py-2 p-md-2 text-center" style="width:28%">Cuota</th></tr>
    </thead>
    <tbody>
      <template v-for="a in actividadesNivel">
      <template v-if="a.publico">
      <tr class="table-primary text-center" :key="a.id"><td colspan="3"><b>{{ a.nombre }}</b></td></tr>
      <tr v-if="a.observaciones" :key="`${a.id}-obs`"><td class="px-1 py-2 p-md-2" colspan="3" v-html="a.observaciones"></td></tr>
      <tr v-for="g in a.grupos" :key="`${a.id}-${g.id}`">
        <td v-if="g.horas.length" class="align-middle px-1 py-2 p-md-2" v-html="mostrarHoras(g.horas)"></td>
        <td v-else class="align-middle px-1 py-2 p-md-2">{{ g.nombre }}</td>
        <td class="align-middle px-1 py-2 p-md-2 text-center" v-html="mostrarNiveles(g.niveles)"></td>
        <td class="align-middle px-1 py-2 p-md-2 text-center" v-html="mostrarCuotas(g.cuotas)"></td>

      </tr>
      </template>
      </template>
    </tbody>
  </table>

  <table v-else class="table table-bordered tabla-semana">
    <tr>
      <td class="p-0 bg-light"></td>
      <td v-for="hora in horasConActividades" :key="hora" class="align-middle p-1 px-md-2 bg-light"><b>{{ hora | rangoHoras }}</b></td>
    </tr>
    <tr v-for="dia of ['1', '2', '3', '4', '5']" :key="dia" class="fila-dia-calendario">
      <td class="align-middle text-center px-1 py-0 px-md-2 py-md-1 bg-light"><b>{{ dia | diaInicial }}</b></td>
      <td v-for="hora in horasConActividades" :key="hora" class="selector-hora p-0">
        <table class="table table-hover tabla-dia m-0">
          <tr v-for="a in actividadesPorHora[dia + '-' + hora]" :key="a.id_actgrupo">
            <td class="p-1 px-md-2 py-md-1">{{ a.nombre_actividad }}</td>
          </tr>
        </table>
      </td>
    </tr>
  </table>

</div>
</template>

<script>
import { api } from '../api/api.js';
import { obtenerCursoActivo, obtenerNiveles } from '../curso.js';
import { convertirHoras } from '../utils.js';

export default {
	name: 'SociosHorarioExtraescolares',
	data () {
		return {
			curso: null,
			actividades: null,
			familia: null,
			niveles: null,

			nivelSeleccionado: {
				id: null,
				nombre: null,
			},
			formatoCuadro: 'Listado',

			actividadesNivel: null,
			actividadesPorHora: null,
			horasConActividades: null,
		}
	},
	created () {
		this.curso = obtenerCursoActivo();
		this.niveles = obtenerNiveles();
		this.obtenerActividades();
	},
	methods: {
		obtenerActividades() {
			api(`/actividades/${this.curso.id_curso}`)
                .then((data) => {
					this.actividades = data.resultado;
					this.seleccionarNivel(0);
				})
		},
		seleccionarNivel(id_nivel) {
			this.nivelSeleccionado.id = id_nivel;
			if (id_nivel == 0) {
				this.nivelSeleccionado.nombre = 'Todos';
			} else {
				for (const n of this.niveles) {
					if (n.id_nivel == id_nivel) {
						this.nivelSeleccionado.nombre = n.nombre;
					}
				}
			}
			this.procesarActividadesNivel();
			this.procesarActividadesPorHora();
		},
		procesarActividadesNivel() {
			const id_nivel = this.nivelSeleccionado.id;
			if (id_nivel == 0) {
				this.actividadesNivel = this.actividades;
				return;
			}
			const actividadesNivel = [];
			for (const a of this.actividades) {
				let disponible = false;
				const gruposDisponibles = [];
				for (const g of a.grupos) {
					if (g.niveles.includes(id_nivel)) {
						disponible = true;
						gruposDisponibles.push(g);
					}
				}
				if (disponible) {
					const actDisponible = { ...a };
					actDisponible.grupos = gruposDisponibles;
					actividadesNivel.push(actDisponible);
				}
			}
			this.actividadesNivel = actividadesNivel;
		},
		procesarActividadesPorHora() {
			const actividadesPorHora = {};
			let horasConActividades = {};
			for (const a of this.actividadesNivel) {
				if (a.periodos.length < 8) {
					// Ignorar las actividades de meses puntuales
					continue;
				}
				for (const g of a.grupos) {
					if (g.horas.length == 0) {
						continue;
					}
					const actgrupo = {
						id_actgrupo: `${a.id}/${g.id}`,
						id_actividad: a.id,
						nombre_actividad: a.nombre,
						id_grupo: g.id,
						nombre_grupo: g.nombre,
						horas: g.horas,
					}
					for (const diahora of g.horas) {
						if (! (diahora in actividadesPorHora)) {
							actividadesPorHora[diahora] = [];
						}
						actividadesPorHora[diahora].push(actgrupo);
						const horaInicio = diahora.substring(2);
						if (! (horaInicio in horasConActividades)) {
							horasConActividades[horaInicio] = true;
						}
					}
				}
			}
			horasConActividades = Object.keys(horasConActividades);
			horasConActividades.sort();
			this.horasConActividades = horasConActividades;
			this.actividadesPorHora = actividadesPorHora;
		},
		// FIXME: repetido, unificar
		mostrarHoras(listaHoras) {
			const convertidas = convertirHoras(listaHoras);
			return convertidas.join('<br />');
		},
		mostrarNiveles(listaNiveles) {
			const gruposNiveles = [];
			let inicio, fin, seccion, siguienteNivel;
			for (const id_nivel of listaNiveles) {
				let n;
				for (n of this.niveles) {
					if (n.id_nivel == id_nivel) {
						break;
					}
				}
				if (n.seccion == seccion && n.id_nivel == siguienteNivel) {
					fin = n.nombre;
					siguienteNivel = n.siguiente;
				} else {
					if (inicio) {
						gruposNiveles.push([inicio, fin]);
					}
					inicio = n.nombre;
					fin = n.nombre;
					seccion = n.seccion;
					siguienteNivel = n.siguiente;
				}
			}
			gruposNiveles.push([inicio, fin]);

			const nivelesTexto = [];
			for (let [inicio, fin] of gruposNiveles) {
				inicio = inicio.replace(' ', '&nbsp;');
				fin = fin.replace(' ', '&nbsp;');
				if (inicio == fin) {
					nivelesTexto.push(inicio);
				} else {
					nivelesTexto.push(`${inicio}<br />↓<br />${fin}`);
				}
			}
			return nivelesTexto.join('<br />');
		},
		mostrarCuotas(cuotas) {
			let cuotasTexto = '';
			const adscripcionesDistintas = Object.keys(cuotas).length;
			for (const adscripcion of ['socio', 'exsocio']) {
				if (! (adscripcion in cuotas)) {
					continue;
				}
				if (adscripcionesDistintas > 1) {
					cuotasTexto += '<i>' + adscripcion + ':</i><br />';
				}
				let periodos = Object.keys(cuotas[adscripcion]);
				periodos.sort();
				for (const periodo of periodos) {
					let listaHoras = Object.keys(cuotas[adscripcion][periodo]);
					listaHoras.sort((a, b) => { parseInt(a) < parseInt(b) });
					for (const hora of listaHoras) {
						if (periodo != 'base') {
							const mesTxt = periodo.substring(4, 6) + '/' + periodo.substring(0, 4);
							cuotasTexto += mesTxt + ' - ';
						}
						if (hora == '0' || listaHoras.length == 1) {
							cuotasTexto += cuotas[adscripcion][periodo][hora] + '&nbsp;€<br />';
						} else {
							cuotasTexto += hora + 'h - ' + cuotas[adscripcion][periodo][hora] + '&nbsp;€<br />';
						}
					}
				}
			}
			return cuotasTexto;
		},
	},
	filters: {
		// TODO: Unificar con SociosFamilias y SociosEditarActividades
		rangoHoras: function(rango) {
			return rango.substring(0, 2) + ':' + rango.substring(2, 7) + ':' + rango.substring(7, 9);
		},
		diaInicial: function(iddia) {
			let diaTxt;
			switch (iddia) {
				case '1': diaTxt = 'L'; break;
				case '2': diaTxt = 'M'; break;
				case '3': diaTxt = 'X'; break;
				case '4': diaTxt = 'J'; break;
				case '5': diaTxt = 'V'; break;
			}
			return diaTxt;
		},
		mostrarHoras: function(listaHoras) {
			const convertidas = convertirHoras(listaHoras);
			return convertidas.join(', ');
		}
	}
}
</script>

/* FIXME: repetido de SociosEditarActividades */
<style scoped>
.tabla-semana td {
  border-width: 3px 1px;
  border-color: #c8c8c8;
}
.tabla-dia td {
  border-width: 1px 0;
}
</style>
